import React, { useState } from 'react';

interface ClaudeHintProps {
  title?: string;
  prompt: string;
}

export function ClaudeHint({ title = 'Do this with Claude instead', prompt }: ClaudeHintProps) {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    void navigator.clipboard.writeText(prompt);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="claude-hint">
      <h4>✦ {title}</h4>
      <p style={{ fontSize: '.8rem', color: '#1e40af' }}>
        Copy this prompt into Claude (with the AutoDocument MCP configured):
      </p>
      <pre>{prompt}</pre>
      <button
        onClick={copy}
        className="btn btn-outline"
        style={{ marginTop: '.5rem', fontSize: '.8rem', padding: '.3rem .6rem' }}
      >
        {copied ? 'Copied!' : 'Copy prompt'}
      </button>
    </div>
  );
}
